// Day to day activity icons
import SpaIcon from "./day-to-day-activities/spa.svg";
import YogaIcon from "./day-to-day-activities/yoga.svg";
import ReadingIcon from "./day-to-day-activities/reading.svg";
import HobbiesIcon from "./day-to-day-activities/hobbies.svg";
import CyclingIcon from "./day-to-day-activities/cycling.svg";
import WalkingIcon from "./day-to-day-activities/walking.svg";
import SwimmingIcon from "./day-to-day-activities/swimming.svg";
import MeetingsIcon from "./day-to-day-activities/meetings.svg";
import BudgetingIcon from "./day-to-day-activities/budgeting.svg";
import ChildcareIcon from "./day-to-day-activities/childcare.svg";
import MeditationIcon from "./day-to-day-activities/meditation.svg";
import NetworkingIcon from "./day-to-day-activities/networking.svg";
import OfficeWorkIcon from "./day-to-day-activities/office_work.svg";
import GymWorkoutIcon from "./day-to-day-activities/gym_workout.svg";
import FamilyTimeIcon from "./day-to-day-activities/family_time.svg";
import SocializingIcon from "./day-to-day-activities/socializing.svg";
import DiyProjectsIcon from "./day-to-day-activities/diy_projects.svg";
import VolunteeringIcon from "./day-to-day-activities/volunteering.svg";
import CookingMealsIcon from "./day-to-day-activities/cooking_meals.svg";
import WorkFromHomeIcon from "./day-to-day-activities/work_from_home.svg";
import CheckingEmailsIcon from "./day-to-day-activities/checking_emails.svg";
import OnlineShoppingIcon from "./day-to-day-activities/online_shopping.svg";
import BusinessTravelIcon from "./day-to-day-activities/business_travel.svg";
import RunningJoggingIcon from "./day-to-day-activities/running_jogging.svg";
import HouseholdChoresIcon from "./day-to-day-activities/household_chores.svg";
import GroceryShoppingIcon from "./day-to-day-activities/grocery_shopping.svg";
import VirtualMeetingsIcon from "./day-to-day-activities/virtual_meetings.svg";
import HealthyMealPrepIcon from "./day-to-day-activities/healthy_meal_prep.svg";
import CommunityServiceIcon from "./day-to-day-activities/community_service.svg";
import OutdoorActivitiesIcon from "./day-to-day-activities/outdoor_activities.svg";
import WellnessTreatmentIcon from "./day-to-day-activities/wellness_treatment.svg";
import LearningANewSkillIcon from "./day-to-day-activities/learning_a_new_skill.svg";
import UsingFinancialAppsIcon from "./day-to-day-activities/using_financial_apps.svg";
import StretchingExercisesIcon from "./day-to-day-activities/stretching_exercises.svg";
import WatchingTvOrMoviesIcon from "./day-to-day-activities/watching_tv_or_movies.svg";
import TravelingForLeisureIcon from "./day-to-day-activities/traveling_for_leisure.svg";
import BrowsingSocialMediaIcon from "./day-to-day-activities/browsing_social_media.svg";
import WatchingEducationVideosIcon from "./day-to-day-activities/watching_education_videos.svg";
import WatchingInvestmentVideosIcon from "./day-to-day-activities/watching_investment_videos.svg";
import AttendingWebinarsSeminarIcon from "./day-to-day-activities/attending_webinars_seminar.svg";

const DayToDayActivityIconMapping = {
  spa: SpaIcon,
  yoga: YogaIcon,
  cycling: CyclingIcon,
  walking: WalkingIcon,
  reading: ReadingIcon,
  hobbies: HobbiesIcon,
  swimming: SwimmingIcon,
  meetings: MeetingsIcon,
  budgeting: BudgetingIcon,
  childcare: ChildcareIcon,
  meditation: MeditationIcon,
  networking: NetworkingIcon,
  gym_workout: GymWorkoutIcon,
  office_work: OfficeWorkIcon,
  family_time: FamilyTimeIcon,
  socializing: SocializingIcon,
  diy_projects: DiyProjectsIcon,
  volunteering: VolunteeringIcon,
  cooking_meals: CookingMealsIcon,
  work_from_home: WorkFromHomeIcon,
  business_travel: BusinessTravelIcon,
  running_jogging: RunningJoggingIcon,
  checking_emails: CheckingEmailsIcon,
  online_shopping: OnlineShoppingIcon,
  virtual_meetings: VirtualMeetingsIcon,
  grocery_shopping: GroceryShoppingIcon,
  household_chores: HouseholdChoresIcon,
  healthy_meal_prep: HealthyMealPrepIcon,
  community_service: CommunityServiceIcon,
  wellness_treatment: WellnessTreatmentIcon,
  outdoor_activities: OutdoorActivitiesIcon,
  learning_a_new_skill: LearningANewSkillIcon,
  using_financial_apps: UsingFinancialAppsIcon,
  stretching_exercises: StretchingExercisesIcon,
  watching_tv_or_movies: WatchingTvOrMoviesIcon,
  traveling_for_leisure: TravelingForLeisureIcon,
  browsing_social_media: BrowsingSocialMediaIcon,
  watching_education_videos: WatchingEducationVideosIcon,
  watching_investment_videos: WatchingInvestmentVideosIcon,
  attending_webinars_seminars: AttendingWebinarsSeminarIcon,
};

export default DayToDayActivityIconMapping;
